// src/api/apiClient.ts
import axios from 'axios';
import { store } from '../app/store';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3080',
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor
apiClient.interceptors.request.use(
    (config) => {
        const token = store.getState().auth.token;
        if (token && config.headers) {
            // FIX: Correctly interpolated the token into the template string
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor (for统一 error handling)
apiClient.interceptors.response.use(
    (response) => {
        // Backend format {code, message, data}
        // On success (code 200), return the data directly
        if (response.data && response.data.code === 200) {
            return response.data.data;
        }
        // Handle business logic errors
        return Promise.reject(new Error(response.data.message || 'An unknown error occurred'));
    },
    (error) => {
        // Handle network or server errors
        return Promise.reject(error);
    }
);

export default apiClient;